import type { Directive } from "vue";

// 计算element的table的高度
export const autoFillBottom: Directive = {
  mounted: (el: HTMLElement) => {
    const rect = el.getBoundingClientRect();
    let tableHeight = window.innerHeight - rect.top - 40;
    // 如果下一个元素是page,需要减掉这个高度
    const netEl = el.nextElementSibling;
    if (netEl != null && netEl.classList.contains("el-pagination")) {
      const pagerRect = netEl.getBoundingClientRect();
      tableHeight -= pagerRect.bottom - pagerRect.top + 20;
    }
    el.style.height = `${tableHeight}px`;
  },
};
